"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _reactRedux = require("react-redux");

var _redial = require("redial");

var _glamor = require("glamor");

var _components = require("components");

var _AccountOption = require("@quixeltools/quixel-ui-library/dist/components/megascans/account/AccountOption");

var _AccountOption2 = _interopRequireDefault(_AccountOption);

var _Columns = require("@quixeltools/quixel-ui-library/dist/components/common/website/Columns");

var _Columns2 = _interopRequireDefault(_Columns);

var _Tabs = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Tabs");

var _Tabs2 = _interopRequireDefault(_Tabs);

var _activity = require("redux/modules/activity");

var _billing = require("redux/modules/billing");

var _customer = require("redux/modules/customer");

var _softwares = require("redux/modules/softwares");

var _payments = require("../../redux/modules/payments");

var _user = require("redux/modules/user");

var userActions = _interopRequireWildcard(_user);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _polyfluid = require("@quixeltools/quixel-ui-library/dist/utils/polyfluid");

var _utils = require("../../EpicMigration/utils");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import FeedbackPopup from '@quixeltools/quixel-ui-library/dist/components/megascans/account/FeedbackPopup';
var page = (0, _glamor.css)({
  maxWidth: (0, _css.unitRem)(52),
  margin: "auto"
}, (0, _polyfluid.polyfluid)({
  paddingTop: {
    smallMedium: 5.625,
    large: [5.625, 7.5]
  },
  paddingBottom: {
    smallMedium: 5.625,
    large: [5.625, 7.5]
  },
  paddingLeft: {
    smallMedium: 3.375,
    large: [3.375, 4.5]
  },
  paddingRight: {
    smallMedium: 3.375,
    large: [3.375, 4.5]
  }
}));

var title = (0, _glamor.css)({
  color: _css.colors.white,
  fontWeight: 300
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    smallMedium: 1.6875,
    large: [1.6875, 2.25]
  },
  marginBottom: {
    smallMedium: 1.6875,
    large: [1.6875, 2.25]
  }
}));

var accountOption = (0, _glamor.css)({
  marginBottom: (0, _css.unitRem)(1.5)
});

var icon = (0, _glamor.css)((0, _polyfluid.polyfluid)({
  width: {
    smallMedium: 3.375,
    large: [3.375, 4.5]
  },
  height: {
    smallMedium: 3.375,
    large: [3.375, 4.5]
  }
}));

var points = function points(greyedOut) {
  return (0, _glamor.css)({
    display: "flex",
    alignItems: "center",
    border: "2px solid #535353",
    borderRadius: "4px",

    color: greyedOut ? _css.colors.gray : _css.colors.white
  }, (0, _polyfluid.polyfluid)({
    minWidth: {
      smallMedium: 3.375,
      large: [3.375, 4.5]
    },
    height: {
      smallMedium: 3.375,
      large: [3.375, 4.5]
    },
    fontSize: {
      smallMedium: [1, 1.40625],
      large: [1.40625, 1.875]
    }
  }));
};

var pointsLabel = (0, _glamor.css)({
  display: "block",
  fontWeight: 500,
  textTransform: "uppercase",

  margin: "0 auto",
  textAlign: "center",
  marginTop: "4px"
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    smallMedium: 0.5625,
    large: [0.5625, 0.75]
  }
}));

var activitySection = (0, _glamor.css)((0, _polyfluid.polyfluid)({
  marginTop: {
    smallMedium: 5.0625,
    large: [5.0625, 6.75]
  }
}), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({ display: "none" }));

var col = (0, _glamor.css)((0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "column",
  "& li": {
    width: "100%"
  }
}));

var onChangePassword = function onChangePassword(context) {
  var dialogs = context.dialogs;


  dialogs.custom(_react2.default.createElement(_components.ChangePasswordPopup, null));
};

var _onCancelSubscriptionClick = function _onCancelSubscriptionClick(context, freeDrops, license) {
  var dialogs = context.dialogs;

  dialogs.custom(_react2.default.createElement(_components.CancelSubscriptionPopup, { drops: freeDrops, license: license }));
};

// const onConfirmationOfCancelSubscriptionClick = (context) => {
//   const { dialogs } = context;

//   dialogs.custom(
//     <ConfirmationOfCancelSubscription />
//   );
// };

var onUpgradeSubscriptionClick = function onUpgradeSubscriptionClick(props, context) {
  var dialogs = context.dialogs;


  if (_payments.upgradeablePlanIds.indexOf(props.planId) === -1) {
    dialogs.custom(_react2.default.createElement(_components.ContactUsPopupContainer, {
      title: "Looking for a change in plan?",
      description: "Leave us a note and we will get back to you soon.",
      tag: "megascans-subscription-monthlyToAnnual-switch-request",
      initialValues: {
        name: _ramda2.default.propOr("", "name", props.customer),
        email: _ramda2.default.propOr("", "user", props.customer),
        subject: _ramda2.default.propOr("Request for switching monthly subscription to Annual Plan", "subject", props),
        comment: _ramda2.default.propOr("", "comment", props)
      }
    }));
  } else {
    dialogs.custom(_react2.default.createElement(_components.UpgradeSubscriptionPopup, null));
  }
};

var onSubscribeClick = function onSubscribeClick(context) {
  var dialogs = context.dialogs;


  dialogs.custom(_react2.default.createElement(_components.RestartSubscriptionPopup, null));
};

var onAddPointsClick = function onAddPointsClick(context) {
  var dialogs = context.dialogs;


  dialogs.custom(_react2.default.createElement(_components.AddPointsPopup, null));
};

var onChangePaymentSettings = function onChangePaymentSettings(context, freeDrops, license, customer) {
  var dialogs = context.dialogs;


  if (customer) {
    dialogs.custom(_react2.default.createElement(_components.PaymentSettingsPopup, {
      onCancelSubscriptionClick: function onCancelSubscriptionClick() {
        return _onCancelSubscriptionClick(context, freeDrops, license);
      }
    }));
  } else {
    dialogs.custom(_react2.default.createElement(_components.PaymentsAndSettingsPopup, {
      onCancelSubscriptionClick: function onCancelSubscriptionClick() {
        return _onCancelSubscriptionClick(context, freeDrops, license);
      }
    }));
  }
};
var onAddPromoCode = function onAddPromoCode(context) {
  var dialogs = context.dialogs;


  dialogs.custom(_react2.default.createElement(_components.AddPromoCodePopupContainer, null));
};

var onChangeAddressSettings = function onChangeAddressSettings(context) {
  var dialogs = context.dialogs;


  dialogs.custom(_react2.default.createElement(_components.AddressSettingsPopup, null));
};

var subscriptionStatus = _ramda2.default.cond([[_ramda2.default.equals("active"), _ramda2.default.always("Active")], [_ramda2.default.equals("expired"), _ramda2.default.always("Inactive")], [_ramda2.default.equals("unpaid"), _ramda2.default.always("Unpaid")], [_ramda2.default.equals("cancelled"), _ramda2.default.always("Inactive")]]);

var label = _ramda2.default.ifElse(_ramda2.default.compose(_ramda2.default.equals(1), _ramda2.default.unary(parseInt)), _ramda2.default.always("Point"), _ramda2.default.always("Points"));

var Points = function Points(props) {
  return _react2.default.createElement(
    "div",
    { className: (0, _glamor.css)(points(props.greyedOut), props.className) },
    _react2.default.createElement(
      "span",
      { className: (0, _glamor.css)({ margin: "0 auto", textAlign: "center" }) },
      props.points,
      _react2.default.createElement(
        "span",
        { className: pointsLabel },
        label(props.points)
      )
    )
  );
};

var SubscriptionDetails = function SubscriptionDetails(_props) {
  var props = _props.props,
      context = _props.context;

  var expiryDate = (0, _moment2.default)(props.expiresAt).format("MMM Do, YYYY");
  var planId = props.planId,
      plans = props.plans;


  var userSubIsAmongCurrentPlans = planId && plans && plans.find(function (plan) {
    return plan.type === planId;
  });

  var showPoints = (0, _utils.shouldShowPoints)(props.planId);
  var showRefillInXDays = props.refillIn > 0 && props.doesGetCharged === true && (0, _utils.shouldShowRefillInXDays)(props.planId);
  var addPointsAllowed = props.doesGetCharged === true && (0, _utils.isAddPointsAllowed)(props.planId);

  var canUpgradeToAnnual = userSubIsAmongCurrentPlans && props.doesGetCharged === true && props.billingCycle === "monthly";

  if (subscriptionStatus(props.status) === "Active") {
    var buttonsArray = canUpgradeToAnnual ? [{
      label: "Switch to Annual Billing",
      subLabel: "New",
      onClick: function onClick() {
        return onUpgradeSubscriptionClick(props, context);
      }
    }] : [];

    buttonsArray.push({
      label: props.customer ? "Payment Settings" : "Billing and Payment Settings",
      onClick: function onClick() {
        return onChangePaymentSettings(context, props.freeDrops, props.license, props.customer);
      }
    });

    if (props.doesGetCharged === true && props.autoRenew === false) buttonsArray.push({
      label: "Re-subscribe",
      onClick: function onClick() {
        return onSubscribeClick(context);
      }
    });

    if (props.hasActivePromo && props.doesGetCharged === true && props.license !== "studio") {
      buttonsArray.push({
        label: "Active promo: " + props.activePromo.code,
        isplain: true
      });
    } else {
      if (props.license !== "educational" && !props.isUnrealUnlimited) buttonsArray.push({
        label: "Add Promo Code",
        onClick: function onClick() {
          return onAddPromoCode(context);
        }
      });
    }

    var subTitle = props.isUnrealUnlimited ? null : props.autoRenew ? subscriptionStatus(props.status) : subscriptionStatus(props.status) + " till " + expiryDate;

    return _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "div",
        { className: accountOption },
        _react2.default.createElement(_AccountOption2.default, {
          icon: _react2.default.createElement("img", { className: icon, src: "/icons/subscription_icon.png" }),
          title: props.userSubscriptionName,
          subtitle: subTitle,
          buttons: buttonsArray
        })
      ),
      showPoints ? _react2.default.createElement(
        "div",
        { className: (0, _glamor.css)(accountOption, { marginBottom: 0 }) },
        _react2.default.createElement(_AccountOption2.default, {
          icon: _react2.default.createElement(Points, { points: props.points }),
          title: showRefillInXDays ? "Refill in " + props.refillIn + " days" : "",
          buttons: addPointsAllowed ? [{
            label: "Add Points",
            onClick: function onClick() {
              return onAddPointsClick(context);
            }
          }] : null
        })
      ) : null
    );
  }

  if (subscriptionStatus(props.status) === "Inactive") {
    var _buttonsArray = [];
    _buttonsArray.push({
      label: props.customer ? "Payment Settings" : "Billing and Payment Settings",
      onClick: function onClick() {
        return onChangePaymentSettings(context, props.freeDrops, props.license, props.customer);
      }
    });
    _buttonsArray.push({ label: "Subscribe", to: "/pricing" });
    return _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "div",
        { className: accountOption },
        _react2.default.createElement(_AccountOption2.default, {
          icon: _react2.default.createElement("img", { className: icon, src: "/icons/subscription_icon.png" }),
          title: props.userSubscriptionName,
          subtitle: subscriptionStatus(props.status),
          buttons: _buttonsArray
        })
      ),
      _react2.default.createElement(
        "div",
        { className: (0, _glamor.css)(accountOption, { marginBottom: 0 }) },
        _react2.default.createElement(_AccountOption2.default, {
          icon: _react2.default.createElement(Points, { points: props.points, greyedOut: true }),
          title: "Points",
          buttons: props.canAcquireAssetsAfterExpiry ? null : [{
            label: "Reactivate subscription to unlock points in container",
            isDisabled: true
          }]
        })
      )
    );
  }

  if (subscriptionStatus(props.status) === "Unpaid") {
    return _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "div",
        { className: accountOption },
        _react2.default.createElement(_AccountOption2.default, {
          icon: _react2.default.createElement("img", { className: icon, src: "/icons/subscription_icon.png" }),
          title: props.userSubscriptionName,
          subtitle: subscriptionStatus(props.status),
          subtitleClassName: (0, _glamor.css)({ color: _css.colors.red }),
          buttons: [{
            label: props.customer ? "Payment Settings" : "Billing and Payment Settings",
            onClick: function onClick() {
              return onChangePaymentSettings(context, props.freeDrops, props.license, props.customer);
            }
          }]
        })
      ),
      _react2.default.createElement(
        "div",
        { className: (0, _glamor.css)(accountOption, { marginBottom: 0 }) },
        _react2.default.createElement(_AccountOption2.default, {
          icon: _react2.default.createElement(Points, { points: props.points, greyedOut: true }),
          title: "Refill in " + props.refillIn + " days",
          titleClassName: (0, _glamor.css)({ color: _css.colors.gray }),
          buttons: [{ label: "" }]
        })
      )
    );
  }

  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "div",
      { className: accountOption },
      _react2.default.createElement(_AccountOption2.default, {
        icon: _react2.default.createElement("img", { className: icon, src: "/icons/subscription_icon.png" }),
        title: "No subscription found",
        buttons: [{ label: "View subscription pricing", to: "/pricing" }, {
          label: props.customer ? "Payment Settings" : "Billing and Payment Settings",
          onClick: function onClick() {
            return onChangePaymentSettings(context, props.freeDrops, props.license, props.customer);
          }
        }]
      })
    )
  );
};
var AccountSection = function AccountSection(props, context) {
  var buttonLinks = [{
    label: "Change Password",
    onClick: function onClick() {
      return onChangePassword(context);
    }
  }];

  if (props.userSubscriptionName && props.customer) {
    buttonLinks.push({
      label: "Change Billing Address",
      onClick: function onClick() {
        return onChangeAddressSettings(context, "address");
      }
    });
  }

  return _react2.default.createElement(
    "section",
    null,
    _react2.default.createElement(
      "h1",
      { className: title },
      "Account"
    ),
    _react2.default.createElement(
      "div",
      { className: accountOption },
      _react2.default.createElement(_AccountOption2.default, {
        icon: _react2.default.createElement("img", { className: icon, src: "/icons/profile_icon.png" }),
        title: props.userEmail,
        buttons: buttonLinks
      })
    ),
    _react2.default.createElement(SubscriptionDetails, { props: props, context: context })
  );
};

AccountSection.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
};

var Account = function Account(props) {
  var user = props.user,
      activity = props.activity,
      billing = props.billing,
      customer = props.customer,
      plans = props.plans;
  var userEmail = user.email,
      subscription = user.subscription,
      packs = user.packs,
      quota = user.quota,
      activePromo = user.activePromo;


  var userSubscriptionName = user.subscription && user.subscription.planName ? user.subscription.planName : null;
  var isUnrealUnlimited = user.subscription && user.subscription.planId === "unreal-unlimited";
  var license = user.subscription && user.subscription.license ? user.subscription.license : null;
  var billingCycle = user.subscription && user.subscription.billing ? user.subscription.billing : null;
  var planId = user.subscription && user.subscription.planId ? user.subscription.planId : null;
  var status = user.subscription && user.subscription.status ? user.subscription.status : null;
  var expiresAt = user.subscription && user.subscription.expiresAt ? user.subscription.expiresAt : null;
  var refillIn = expiresAt ? (0, _moment2.default)(expiresAt).add(2, "days").diff((0, _moment2.default)(), "days") : null;
  var points = user.quota && user.quota.currentQuota ? user.quota.currentQuota : 0;
  var canAcquireAssetsAfterExpiry = user.subscription && user.subscription.canAcquireAssetsAfterExpiry || false;

  var isActive = user.subscription && user.subscription.isActive;
  var autoRenew = user.subscription && user.subscription.autoRenew;
  var doesGetCharged = user.subscription && user.subscription.doesGetCharged;
  var freeDrops = planId === "personal-0-app" || planId === "personal-0" || planId === "personal-0-annual" ? 2 : 5;

  var hasActivePromo = false;

  if (activePromo && activePromo.activeTill) {
    var activeTillTime = (0, _moment2.default)(activePromo.activeTill).valueOf();
    var nowTime = new Date().getTime();
    hasActivePromo = activeTillTime > new Date().getTime();
  }
  if (!hasActivePromo) {
    activePromo = props.activePromo;
    if (activePromo && activePromo.activeTill) {
      var _activeTillTime = (0, _moment2.default)(activePromo.activeTill).valueOf();
      var _nowTime = new Date().getTime();
      hasActivePromo = _activeTillTime > new Date().getTime();
    }
  }

  return _react2.default.createElement(
    "div",
    { className: page },
    _react2.default.createElement(
      _Columns2.default,
      { className: col, n: 2 },
      _react2.default.createElement(AccountSection, {
        userEmail: userEmail,
        userSubscriptionName: userSubscriptionName,
        isUnrealUnlimited: isUnrealUnlimited,
        planId: planId,
        license: license,
        billingCycle: billingCycle,
        billing: billing,
        status: status,
        refillIn: refillIn,
        expiresAt: expiresAt,
        points: points,
        packs: packs,
        isActive: isActive,
        autoRenew: autoRenew,
        doesGetCharged: doesGetCharged,
        canAcquireAssetsAfterExpiry: canAcquireAssetsAfterExpiry,
        activePromo: activePromo,
        hasActivePromo: hasActivePromo,
        freeDrops: freeDrops,
        plans: plans,
        customer: customer.customer
      }),
      _react2.default.createElement(_components.DownloadsSection, {
        className: (0, _glamor.css)((0, _css.maxWidth)(_css.breakpoints.mediumlarge)({ display: "none" })),
        softwares: props.softwares
      })
    ),
    _react2.default.createElement(
      "section",
      { className: activitySection },
      _react2.default.createElement(
        _Tabs2.default,
        { active: 0 },
        _react2.default.createElement(
          _Tabs.Tab,
          { label: "Activity" },
          _react2.default.createElement(_components.UserActivity, { activity: activity })
        ),
        _react2.default.createElement(
          _Tabs.Tab,
          { label: "Billing History" },
          _react2.default.createElement(_components.UserBilling, { billing: billing })
        ),
        _react2.default.createElement(
          _Tabs.Tab,
          { label: "Authorised Apps" },
          _react2.default.createElement(_components.UserAuthorisedApplications, null)
        ),
        _react2.default.createElement(
          _Tabs.Tab,
          { label: "Developer Apps" },
          _react2.default.createElement(_components.UserApplications, null)
        )
      )
    )
  );
};

exports.default = (0, _redial.provideHooks)({
  fetch: function fetch(_ref) {
    var dispatch = _ref.store.dispatch;

    var user = dispatch(userActions.load());
    var billingInfo = dispatch((0, _billing.loadBillingData)());
    var activity = dispatch((0, _activity.loadUserActivityData)());
    var customerInfo = dispatch((0, _customer.getCustomer)());
    var studio = dispatch((0, _softwares.loadMixerUpdater)());
    var upgradeParams = dispatch((0, _payments.getUpgradeParams)());
    return _bluebird2.default.all([billingInfo, activity, customerInfo, studio, upgradeParams, user]);
  }
})((0, _reactRedux.connect)(function (state) {
  return {
    user: state.user,
    activePromo: state.payments.activePromo,
    activity: state.activity.userActivities,
    billing: state.billing.billingInfo,
    softwares: state.softwares,
    customer: state.customer,
    plans: state.subscriptions.plansDecorated
  };
})(Account));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Account/Account.jsx
// module id = 2728
// module chunks = 0